export { default } from './FileIcon';
